import { Injectable } from '@angular/core';
import { ICustomerSource } from '@core/interfaces/customer/customer-source.interface';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { ICustomer } from '@core/interfaces/customer/customer.interface';
import { Customer } from '@core/models/customer/customer.model';
import { HttpService } from '@interticket/core';

@Injectable()
export class CustomerSourceService implements ICustomerSource {

  private readonly serviceVersion: string = environment.modules.core.customer.version;
  private readonly serviceBaseUrl: string = `/${this.serviceVersion}/cart/web/customer`;

  constructor(
    private httpService: HttpService
  ) { }

  createCustomer(customer: Customer): Observable<ICustomer> {
    return this.httpService.post<ICustomer>(`${this.serviceBaseUrl}/${customer.type.toLowerCase()}`, customer);
  }

  updateCustomer(customer: Customer): Observable<ICustomer> {
    return this.httpService.put<ICustomer>(`${this.serviceBaseUrl}/${customer.type.toLowerCase()}/${customer.id}`, customer);
  }

}
